var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0005 15H11.9572V10.0168C11.9572 8.71244 11.4812 7.822 10.4343 7.822C9.63363 7.822 9.18834 8.42289 8.98108 9.00199C8.90336 9.20985 8.9155 9.4994 8.9155 9.78896V15H5.90052C5.90052 15 5.93938 6.17274 5.90052 5.37034H8.9155V6.88164C9.09362 6.22084 10.0571 5.27776 11.5945 5.27776C13.5019 5.27776 15.0005 6.66289 15.0005 9.64554V15ZM2.7413 4.11111H2.72043C1.67669 4.11111 1 3.42567 1 2.55682C1 1.67107 1.69669 1 2.76131 1C3.82505 1 4.47913 1.66938 4.5 2.55429C4.5 3.42313 3.82505 4.11111 2.7413 4.11111ZM1.34948 5.66668H4.14948V15H1.34948V5.66668Z",
    fill: "#151515"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0eb789ca.svg";
export { ForwardRef as ReactComponent };